/* eslint-disable @tanstack/query/exhaustive-deps -- doesn't work with the key factory*/
import { queryOptions } from "@tanstack/react-query";
import { type apiContract } from "@kanpla/api-contract";
import { type ClientInferRequest } from "@ts-rest/core";

import { type UserIdentifier } from "~/providers/store/employee";
import { type DiningOption } from "~/providers/store/basket";

import { productsKeys } from "./keys";
import { getUserProducts } from "./requests";

export type GetProductsQueryParams = ClientInferRequest<
  typeof apiContract.v1.pos.tills.getUserProducts
>["query"];

export const productsQuery = ({
  tillId,
  userIdentifier,
  diningOption,
  mode,
  include
}: {
  tillId: string;
  userIdentifier: UserIdentifier | null;
  diningOption: DiningOption | null;
  mode: "identify" | "display";
  include?: GetProductsQueryParams["include"];
}) =>
  queryOptions({
    queryKey: productsKeys.list({
      userIdentifierValue: userIdentifier?.value ?? null,
      diningOption,
      mode
    }),
    queryFn: () => {
      return getUserProducts(tillId, {
        diningOptionInputId: diningOption?.inputId ?? undefined,
        diningOptionValue: diningOption?.value ?? undefined,
        userChildHex:
          userIdentifier?.type === "child-card-hex"
            ? userIdentifier.value
            : undefined,
        userChildId:
          userIdentifier?.type === "child-id"
            ? userIdentifier.value
            : undefined,
        groupName:
          userIdentifier?.type === "group-name"
            ? userIdentifier.value
            : undefined,
        include
      });
    }
  });
